import { createSlice } from '@reduxjs/toolkit'

export const companyContextSlice = createSlice({
    name: 'companyContext',
    initialState: {
        activeCompany: null,        // { nit, nombre }
        availableCompanies: [],     // Array de empresas disponibles
        isMultiCompany: false       // Flag para saber si el usuario tiene múltiples empresas
    },
    reducers: {
        setActiveCompany: (state, action) => {
            state.activeCompany = action.payload
            // Persistir en localStorage
            localStorage.setItem('activeCompany', JSON.stringify(action.payload))
        },
        setAvailableCompanies: (state, action) => {
            state.availableCompanies = action.payload
            state.isMultiCompany = action.payload.length > 1
        },
        initializeCompanyContext: (state, action) => {
            const { companies } = action.payload
            state.availableCompanies = companies
            state.isMultiCompany = companies.length > 1

            // Intentar cargar de localStorage, sino usar la primera
            const saved = localStorage.getItem('activeCompany')
            if (saved) {
                try {
                    const savedCompany = JSON.parse(saved)
                    // Validar que siga siendo una empresa válida
                    if (companies.find(c => c.nit === savedCompany.nit)) {
                        state.activeCompany = savedCompany
                        return
                    }
                } catch (e) {
                    console.error('Error parsing activeCompany from localStorage:', e)
                }
            }
            // Si no hay guardado válido, usar la primera empresa
            state.activeCompany = companies[0] || null
        },
        clearCompanyContext: (state) => {
            state.activeCompany = null
            state.availableCompanies = []
            state.isMultiCompany = false
            localStorage.removeItem('activeCompany')
        }
    }
})

export const {
    setActiveCompany,
    setAvailableCompanies,
    initializeCompanyContext,
    clearCompanyContext
} = companyContextSlice.actions

export default companyContextSlice.reducer
